// 必要なモジュールや型定義をインポート
import UserFrame from "../organisms/UserFrame"; // ユーザー用共通フレーム
import { 
    Box, Button, CardContent, Container, Drawer, Grid, 
    List, ListItem, ListItemButton, ListItemText, Stack, Typography, useMediaQuery 
} from '@mui/material'; // Material-UIコンポーネント
import { useEffect, useState } from "react"; // Reactのフック
import ChevronRightIcon from '@mui/icons-material/ChevronRight'; // 右向き矢印アイコン
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'; // 左向き矢印アイコン
import { GuestMaterialType } from "../types/guestMaterial"; // 資料データの型定義
import { PracticeType, TestType} from "../types/guestTestTemplate"; // 問題の型定義
import GTDescription from "../organisms/GTDescription";
import GTSideMenu from "../organisms/GTSideMenu";
import GTTest from "../organisms/GTTest";
import GTTestList from "../organisms/GTTestList";
import GTResult from "../organisms/GTResult";

// プロパティの型定義
type GuestTestTemplateProps = {
    practiceList: PracticeType[][], // 複数の練習問題リスト
    questionBook: number, // 現在選択されている問題集ID
    userId: number // ユーザーID
    title: string; // ページタイトル
    data: GuestMaterialType[]; // 表示する資料データのリスト
    no: string | null; // noを追加
    questionList: TestType[];
};


/** Entry 認知特性テストテンプレート */
const GuestTestTemplate: React.FC<GuestTestTemplateProps> = ({ title, data, no, questionList }) => {

    const [mode, setMode] = useState<'desc' | 'test' | 'result'>('desc'); //表示モード

    const [tryingNo, setTryingNo] = useState(0); // 回答中No
    const [scores, setScores] = useState([0,0,0,0,0,0]);

    const ua: (number|null)[] = []; // 回答リスト初期化
    for(let i = 0; i < 35; i++) {
        ua.push(null);
    }
    const [answers, setAnswers] = useState<(number|null)[]>(ua); // 回答リスト

    const matches: boolean = useMediaQuery("(min-width:640px)"); // 画面幅が640px以上かどうかを判定
    const [open, setOpen] = useState(matches); // サイドメニューの開閉状態

    useEffect(()=>{
        if (mode ===`test`) {
            setTryingNo(0);
        }
    }, [mode])

    useEffect(() => {
        if (mode ===`test` && !matches) {
            setOpen(false);
        }
    },[tryingNo])

    return (
        <UserFrame title={title} isEntry>
          <Box height={'100%'}>
            {/* 上部の「目次を表示/隠す」ボタン */}
            <Box sx={{display: 'flex', justifyContent: 'flex-end', minHeight: '2.5rem', position: 'fixed', zIndex: '10'}} bgcolor={'lightgray'} width={'100%'}>
                <Box padding={1}>
                    <Button
                        startIcon={open ? <ChevronRightIcon /> : <ChevronLeftIcon />} // ボタンのアイコン
                        onClick={() => setOpen(!open)} // ボタン押下時の処理
                        size="small"
                        color="secondary"
                    >
                        {`${open ? "目次を隠す" : "目次を表示"}`} {/* ボタンのラベル */}
                    </Button>
                </Box>
            </Box>
            <Box height={'3rem'}/> {/* ボタン分の高さ調整 */}
            
            {/* PC画面レイアウト */}
            {matches ?
            <Grid container sx={{position: 'fixed'}}>
                {/* メインコンテンツ */}
                <Grid item xs={open ? 7 : 12} maxHeight={`${document.documentElement.clientHeight * 0.9}px`} sx={{overflowY: 'scroll'}}>
                    {mode === 'desc' && <GTDescription />}
                    {mode === 'test' && <GTTest 
                        data={questionList}
                        setMode={setMode}
                        tryingNo={tryingNo}
                        setTryingNo={setTryingNo}
                        answers={answers}
                        setAnswers={setAnswers}
                        scores={scores}
                        setScores={setScores}
                    />}
                    {mode === 'result' && <GTResult answers={answers} scores={scores}/>}

                    <Box height={'10rem'}/> {/* スクロール調整用の余白 */}
                </Grid>
                {/* サイドメニュー */}
                {open && <Grid item xs={5}>
                    <Container maxWidth='md'>
                        {mode !== 'test' ?
                            <GTSideMenu setMode={setMode}/>
                            :
                            <GTTestList answers={answers} setTryingNo={setTryingNo} data={questionList}/>
                        }
                    </Container>
                </Grid>}
            </Grid>
            :
            /* スマートフォン画面レイアウト */
            <Box height={`auto`} width={'100%'} sx={{overflowY:'scroll', overflowX:'hidden'}}>
                {mode === 'desc' && <GTDescription />}
                {mode === 'test' && <GTTest 
                    data={questionList}
                    setMode={setMode}
                    tryingNo={tryingNo}
                    setTryingNo={setTryingNo}
                    answers={answers}
                    setAnswers={setAnswers}
                    scores={scores}
                    setScores={setScores}
                />}
                {mode === 'result' && <GTResult answers={answers} scores={scores}/>}
            </Box>}
            
            {/* スマホ用Drawerメニュー */}
            {!matches && <Drawer open={open} variant="persistent" anchor="right">
                <Box padding={1} width={"300px"}>
                    <Button
                        startIcon={open ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                        onClick={() => setOpen(!open)}
                        size="small"
                        color="secondary"
                    >
                        {`${open ? "目次を隠す" : "目次を表示"}`}
                    </Button>
                </Box>
                <Container>
                    {mode !== 'test' ?
                        <GTSideMenu setMode={setMode}/>
                        :
                        <GTTestList answers={answers} setTryingNo={setTryingNo} data={questionList}/>
                    }
                </Container>
            </Drawer>}
          </Box>
        </UserFrame>
    );
}

export default GuestTestTemplate;
